<style lang="scss" scoped>
@import '$vars';
main {
  >header {
    padding: 20px 0;
    nav {
      display: flex;
      align-items: center;
      margin-left: auto;
      a {
        color: #888;
        text-transform: uppercase;
        letter-spacing: 1px;
        margin: 0 10px;
        &:last-child {
          color: $color-blue;
          font-weight: bold
        }
      }
    }
  }
  .banner-1 {
    background: color-gradient-alpha(0.2);
    li {
      padding: 20px 0;
      margin: 0;
      width: 33.33%;
      display: flex;
      justify-content: center;
      align-items: center;
      &:last-child {
        text-align: center;
        background: #0664be;
      }
      img {
        margin-right: 10px
      }
    }
    p {
      white-space: nowrap;
      margin: 0;
      img {
        margin-right: 10px;
      }
    }
    a:hover {
      text-decoration: none !important
    }
    h5 {
      color: #fff ;
      font-size: 1.2em;
      img {
        vertical-align: sub
      }
    }
  }
  .banner-2 {
    padding: 100px 0 160px;
    background: $color-gradient;
    h1, p {
      color: white;
    }
    form {
      background: white;
      margin: 60px auto;
      height: 74px;
      border-radius: 37px;
      padding: 10px;
      input[type=text] {
        vertical-align: middle;
        font-size: 22px;
        outline: 0 !important;
        border: 0;
        padding-left: 21px;
      }
    }
  }
  .banner-3 {
    .download {
      h3, p {
        color: white;
        margin-right: 230px
      }
      min-height: 200px;
      padding: 50px;
      margin: -120px auto 40px auto;
      background: #0664be;
      background-image: url("../assets/img/home/phones.png");
      background-position: right bottom;
      background-repeat: no-repeat
    }
    h1 {
      color: #444;
      font-size: 3.5em
    }
    figure {
      img {
        width: 100%;
      }
    }
    padding-bottom: 60px
  }
  .banner-4 {
    background: #0664be;
    padding: 60px 0;
    h1, h4 {
      font-family: 'Open Sans';
      color: white;
      font-weight: normal
    }
    h1 {
      font-size: 4em;
      margin: 0
    }
    h4 {
      font-size: 1em
    }
    li {
      text-align: center;
      padding: 0 10px
    }
  }
  figure {
    p {
      padding: 0 40px
    }
  }
  .banner-5 {
    background-image: url("../assets/img/home/img-medico.jpg");
    background-size: cover;
    background-position: -260px center;
    background-repeat: no-repeat;
    padding: 60px 0;
    >section {
      padding-left: 240px;
      h1, h5, p {
        color: #000 !important;
      }
      h1 {
        margin-bottom: 60px;
      }
      h5 {
        margin: 20px 0;
      }
      ul {
        flex-wrap: wrap;
        li {
          img {
            height: 42px;
          }
          padding-right: 60px
        }
      }
    }
  }
  .banner-6 {
    >section {
      padding: 60px 0;
      li {
        padding: 0 20px
      }
      img {
        height: 191px;
        margin-bottom: 30px
      }
    }
  }
}
.container {
  min-height: auto
}
.logout {
  width: 40px;
      margin: auto 0;
}
</style>

<template>
  <main v-if="false && loaded">
    <header>
      <div class="container grid-xl navbar">
        <img src="@/assets/img/home/logo_web.png" alt="" />
        <nav>
            <router-link to="/">Home</router-link>
            <router-link to="/">Nossos serviços</router-link>
            <router-link to="/">Meu doutor</router-link>
            <router-link to="/">Ajuda</router-link>
            <router-link to="/">Fale conosco</router-link>
            <a @click="login()">Entrar</a>
        </nav>
        <dr-icon v-if="$store.getters.$_checkAuth" @click.native="$router.push('/logout')" name="logout" fill="gradient" class="logout clickable"></dr-icon>
      </div>
    </header>
    <main>
      <div class="banner-1">
        <section class="container grid-xl">
          <ul class="list-unstyled flex-space_between">
            <li>
              <img src="@/assets/img/home/ico-tel.png" class="d-inline" />
              <p>
                <strong>Entre em contato conosco</strong><br />
                34441111 &bull; 08000565505
              </p>
            </li>
            <li>
              <img src="@/assets/img/home/ico-atendimento.png" class="d-inline" />
              <p>
                <strong>Atendimento Online</strong><br />
                De segunda a sexta das 8h às 18h
              </p>
            </li>
            <li>
              <router-link to="/register/pre-registration"><h5><img src="@/assets/img/home/ico-medico.png" /> Cadastro médicos</h5></router-link>
            </li>
          </ul>
        </section>
      </div>
      <div class="banner-2 text-center">
        <h1>A maior rede com médicos especializados</h1>
        <p>No Dr.Conecta, você encontra de forma fácil e prática, os melhores médicos especializados.</p>
        <form action="" class="col-8">
          <input type="text" placeholder="digite a especialidade que procura" class="col-10" />
          <input type="submit" class="btn btn-primary" value="Buscar" />
        </form>
      </div>
      <div class="banner-3">
        <section class="container grid-xl download">
          <h3>Baixe agora o nosso aplicativo e marque sua consulta direto do celular</h3>
          <p>Baixe agora o aplicativo e agende agora uma consulta direto pelo celular.</p>
          <img src="@/assets/img/home/dl_apple.png" alt="" />
          <img src="@/assets/img/home/dl_google.png" alt="" />
        </section>
        <article class="container grid-xl">
          <h1>Sobre o Dr. Conecta</h1>
          <figure class="flex-middle">
            <img src="@/assets/img/home/img_drconecta.jpg" alt="" />
            <p>
              Dr.Conecta vem para revolucionar o sistema de atendimento à saúde no Brasil, reunindo os melhores médicos especialistas, labotarótios, clínicas e procedimentos hospitalares de baixa complexidade a preços bastante competitivos, acesso rápido às agendas e histórico eletrônico do paciente.
            </p>
          </figure>
        </article>
      </div>
      <div class="banner-4">
        <section class="container grid-xl">
          <ul class="list-unstyled flex-space_around">
            <li>
              <h1><strong>4</strong> mil</h1>
              <h4>Médicos especializados</h4>
            </li>
            <li>
              <h1><strong>10</strong> mil</h1>
              <h4>Consultas realizadas</h4>
            </li>
            <li>
              <h1><strong>45</strong> mil</h1>
              <h4>Clientes satisfeitos</h4>
            </li>
            <li>
              <h1><strong>14</strong> mil</h1>
              <h4>Exames realizados</h4>
            </li>
          </ul>
        </section>
      </div>
      <div class="banner-5">
        <section class="container grid-xl">
          <h1>Nossas especializações</h1>
          <ul class="list-unstyled flex-space_between col-12">
            <li class="col-4">
              <img src="@/assets/img/home/ico-otorrino.png" />
              <h5>Otorrino</h5>
              <p>I wonder, if there is way to rename multiple files in visual studio code? I have tried to use find and replace, no luck.</p>
            </li>
            <li class="col-4">
              <img src="@/assets/img/home/ico-ortopedia.png" />
              <h5>Otorrino</h5>
              <p>I wonder, if there is way to rename multiple files in visual studio code? I have tried to use find and replace, no luck.</p>
            </li>
            <li class="col-4">
              <img src="@/assets/img/home/ico-oftalmo.png" />
              <h5>Otorrino</h5>
              <p>I wonder, if there is way to rename multiple files in visual studio code? I have tried to use find and replace, no luck.</p>
            </li>
            <li class="col-4">
              <img src="@/assets/img/home/ico-cardiologista.png" />
              <h5>Otorrino</h5>
              <p>I wonder, if there is way to rename multiple files in visual studio code? I have tried to use find and replace, no luck.</p>
            </li>
            <li class="col-4">
              <img src="@/assets/img/home/ico-laboratorio.png" />
              <h5>Otorrino</h5>
              <p>I wonder, if there is way to rename multiple files in visual studio code? I have tried to use find and replace, no luck.</p>
            </li>
            <li class="col-4">
              <img src="@/assets/img/home/ico-hospital.png" />
              <h5>Otorrino</h5>
              <p>I wonder, if there is way to rename multiple files in visual studio code? I have tried to use find and replace, no luck.</p>
            </li>
          </ul>
        </section>
      </div>
      <div class="banner-6">
        <section class="container grid-xl">
          <ul class="list-unstyled flex-space_around text-center">
            <li>
              <img src="@/assets/img/home/ilu-procure.jpg" />
              <h5>Procure seu médico</h5>
              <p>O <strong>Dr.Conecta</strong> te ajuda a encontrar o melhor médico para você</p>
            </li>
            <li>
              <img src="@/assets/img/home/ilu-agende.jpg" />
              <h5>Agende sua consulta</h5>
              <p>De forma fácil e prática você agenda sua consulta em minutos</p>
            </li>
            <li>
              <img src="@/assets/img/home/ilu-pague.jpg" />
              <h5>Faça o pagamento</h5>
              <p>Depois é só fazer o pagamento com o seu cartão de crédito</p>
            </li>
          </ul>
        </section>
      </div>
      <dr-login :active.sync="loginActive" @cancel="loginActive = false"></dr-login>
      <dr-footer></dr-footer>
    </main>
  </main>
</template>
<script>
import Login from '@/components/modals//login'

export default {
  components: {
    'dr-login': Login
  },
  data () {
    return {
      loginActive: false,
      loaded: false
    }
  },

  created () {
    if (document.domain === 'medico.drconecta.com.br') {
      document.location = 'https://drconecta.com.br/'

      return
    }

    this.$router.push({ name: 'Login' })
  },

  mounted () {
    if (this.fn_CHECK_AUTH()) {
      if (this.fn_IS_ADMIN()) {
        this.$router.replace('/admin')
      } else {
        this.$router.replace('/doctor')
      }
      return
    }
    this.loaded = true
    this.fn_HIDE_PROGRESS()
  },
  methods: {
    login () {
      if (this.$store.getters.$_checkAuth) {
        this.$router.push('/doctor')
      } else {
        this.loginActive = true
      }
    }
  }
}
</script>
